import { useInnovyzeTheme } from './innovyzeTheme';
import useWeaveThemeMaterial from './weaveThemeMaterial';
export default function useDefaultTheme({ theme, weave, isWeaveActive, }) {
    const innovyzeTheme = useInnovyzeTheme();
    const { theme: weaveTheme } = useWeaveThemeMaterial(weave);
    if (weave && isWeaveActive)
        return weaveTheme;
    if (theme)
        return theme;
    return innovyzeTheme;
}
